import { Adresse } from "@/model/Adresse";

export class Absenderinformationen {
  vermittlernummer = "";
  anrede = "";
  titel = "";
  vorname = "";
  nachname = "";
  adresse = new Adresse();
  email = "";
  telefon = "";
  mobil = "";
  fax = "";
  organisation = "";
}
